import { EnvObject } from './types'

export const environments: EnvObject[] = [
    {
        env: 'development',
        host: ['www.devpantamera.nu'],
        assetsUrl: 'https://www.devpantamera.nu:9850',
        urls: {
            site: 'https://www.devpantamera.nu:8000',
            api: `https://www.devpantamera.nu:8000/api`,
            login: 'https://login.www.devpantamera.nu:5001',
        },
    },
    {
        env: 'integration',
        host: ['integration.pantamera.nu'],
        urls: {
            site: 'https://integration.pantamera.nu',
            api: `https://integration.pantamera.nu/api`,
            login: 'https://login.www.rp-pm-test.pantamera.nu',
        },
    },
    {
        env: 'preproduction',
        host: ['preproduction.pantamera.nu'],
        urls: {
            site: 'https://preproduction.pantamera.nu',
            api: `https://preproduction.pantamera.nu/api`,
            login: 'https://login.www.rp-pm-test.pantamera.nu',
        },
    },
    {
        env: 'production',
        host: ['www.pantamera.nu'],
        urls: {
            site: 'https://www.pantamera.nu',
            api: `https://www.pantamera.nu/api`,
            login: 'https://login.www.rp-pm-prod.pantamera.nu',
        },
    },
]
